import { CompanySize } from 'types';

export const registerCompanyDefaultValues = {
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  companyName: '',
  industry: '',
  companySize: Object.values(CompanySize).indexOf(CompanySize.ElevenToFifteen),
  number: '',
};
